import { useQuery } from "react-query";
import { getAppointmentTypesWithDefaults } from "../api/getAppointmentTypesWithDefaults";

export const useAppointmentTypesWithDefaults = () => {
  return useQuery("appointment-types-with-defaults", getAppointmentTypesWithDefaults);
};
